import React, {Component, Fragment} from 'react'
import {Breadcrumb, Button, Card, message, Popconfirm, Row, Steps} from 'antd'
import PayQueryApi from '../../../../../api/PayQuery'

import {get, isEmpty, omit} from 'lodash'
import omitEmpty from 'omit-empty'
import Members from '../../../../../api/Members'
import Employees from '../../../../../api/Employees'
import style from './style.css'
import Overview from '../Form/Overview'
import Statutory from '../Form/Statutory'

const Step = Steps.Step

class AddPayQuery extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.payQueryKey = get(props.match, 'params.payQueryKey')
    this.type = this.payQueryKey ? 'update' : 'new'
    this.state = {
      submitting: false,
      memberFetching: true,
      payQuery: get(props.location, 'state.payQuery') || {},
      member: get(props.location, 'state.member') || {},
      employee: get(props.location, 'state.employee') || {},
      current: 0,
    }
    this.payQueryApi = new PayQueryApi()
    this.api = new Employees()
    this.memberApi = new Members()
  }

  async componentDidMount() {
    if (isEmpty(this.state.member)) {
      try {
        this.setState({
          memberFetching: true,
        })
        const employeeResponse = await this.api.getMember(this.key)
        const memberResponse = await this.memberApi.get(this.key)
        let member = await memberResponse.json()
        let employee = await employeeResponse.json()
        let payQuery = this.state.payQuery
        if (this.payQueryKey) {
          payQuery = await this.payQueryApi.get(this.payQueryKey)
        }
        this.setState({
          member,
          employee,
          payQuery,
          memberFetching: false,
          employeeFetching: false,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
        this.setState({
          memberFetching: false,
          employeeFetching: false,
        })
      }
    } else {
      this.setState({memberFetching: false})
    }
  }

  updatePayQuery = (attribute, value) => {
    const {payQuery} = this.state
    this.setState({
      payQuery: Object.assign({}, payQuery, {[attribute]: value}),
    })
  }
  checkOverviewForm = () => {
    return new Promise((res, rej) => {
      this.overviewCmp.validateFields((err, values) => {
        if (!err) {
          values.contract = this.state.payQuery.contract
          let date = {
            start: values.date.start.format('YYYY-MM-DD'),
            expiry:
              values.date.expiry && values.date.expiry.format('YYYY-MM-DD'),
          }
          this.setState({
            payQuery: Object.assign({}, this.state.payQuery, {...values, date}),
          })
          res(true)
        }
      })
    })
  }
  checkStatutory = () => {
    return new Promise((res, rej) => {
      this.statutoryCmp.validateFields((err, values) => {
        if (!err) {
          this.setState({
            payQuery: Object.assign({}, this.state.payQuery, values),
          })
          res(true)
        } else {
          message.error('Not Valid')
          rej(false)
        }
      })
    })
  }
  prev = () => {
    const current = this.state.current - 1
    this.setState({current})
  }
  next = async () => {
    let valid = false
    switch (this.state.current) {
      case 0:
        valid = await this.checkOverviewForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({current})
    }
  }
  submit = async () => {
    const valid = await this.checkStatutory()
    if (valid) {
      this.setState({submitting: true})
      try {
        let payQuery = this.state.payQuery
        payQuery = omit(payQuery, ['_key'])
        payQuery = Object.assign({}, payQuery, {
          employee: Object.assign({}, payQuery.employee, {
            _id: this.state.employee._id,
          }),
        })
        payQuery = omitEmpty(payQuery)
        await this.payQueryApi.create(payQuery)
        this.props.history.replace({
          pathname: `/people/member/${this.key}/`,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
      this.setState({submitting: false})
    }
  }

  update = async () => {
    const valid = await this.checkStatutory()
    if (valid) {
      this.setState({submitting: true})
      try {
        let {payQuery} = this.state
        payQuery = omit(payQuery, [
          'code',
          'status',
          'employee',
          'state',
          '_history',
          'owner',
          'revision',
        ])
        payQuery = omitEmpty(payQuery)
        await this.payQueryApi.update(payQuery)
        this.props.history.replace({
          pathname: `/people/member/${this.key}/payQuery/${payQuery._key}/view`,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
      this.setState({submitting: false})
    }
  }

  render() {
    const titles = {
      new: 'Create new Employee PayQuery',
      update: 'Update Employee PayQuery',
    }
    const descriptions = {
      new: 'You can add new Employee PayQuery by following the steps below.',
      update: 'You need to follow the steps below to update Employee PayQuery.',
    }
    const {type} = this
    const {member, employee, memberFetching, payQuery} = this.state
    const submitButton = {
      new: (
        <Popconfirm title="Sure to submit?" onConfirm={() => this.submit()}>
          <Button loading={this.state.submitting} type="primary">
            Submit
          </Button>
        </Popconfirm>
      ),
      update: (
        <Popconfirm title="Sure to Update?" onConfirm={() => this.update()}>
          <Button loading={this.state.submitting} type="primary">
            Update
          </Button>
        </Popconfirm>
      ),
    }
    const steps = [
      {
        title: 'Overview',
        content: (
          <Overview
            updatePayQuery={this.updatePayQuery}
            employee={employee}
            member={member}
            ref={child => {
              this.overviewCmp = child
            }}
            payQuery={payQuery}
            loading={this.state.memberFetching}
          />
        ),
      },
      {
        title: 'Statutory Details',
        content: (
          <Statutory
            updatePayQuery={this.updatePayQuery}
            employee={employee}
            ref={child => {
              this.statutoryCmp = child
            }}
            payQuery={payQuery}
            loading={this.state.memberFetching}
          />
        ),
        key: 'statutory',
      },
    ]
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Sales</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team/">
                Team List
              </Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${this.key}/#payQuery`}>
                {member.fn}
              </Breadcrumb.Item>
              <Breadcrumb.Item
                href={
                  this.type === 'update' &&
                  `#/people/member/${this.key}/payQuery/${
                    this.payQueryKey
                  }/view`
                }>
                {this.type === 'update' ? payQuery.code : titles[this.type]}
              </Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>{titles[this.type]}</h2>
            <p className={style.paragraph}>{descriptions[this.type]}</p>
          </Row>
        </Card>
        <Card loading={memberFetching} className={style.contentCard}>
          <Steps current={this.state.current}>
            {steps.map(item => (
              <Step key={item.key} title={item.title} />
            ))}
          </Steps>
          <div
            style={{marginTop: '50px', marginBottom: '10px'}}
            className="steps-content">
            {steps[this.state.current].content}
          </div>
          <div
            className="steps-action"
            style={{textAlign: 'center', paddingTop: 20}}>
            {this.state.current > 0 && (
              <Button style={{marginRight: 8}} onClick={() => this.prev()}>
                Previous
              </Button>
            )}
            {this.state.current < steps.length - 1 && (
              <Button
                style={{width: '100px', marginRight: 8}}
                type="primary"
                onClick={() => this.next()}>
                Next
              </Button>
            )}

            {this.state.current === steps.length - 1 &&
              (submitButton[type] || (
                <Popconfirm
                  title="Sure to submit?"
                  onConfirm={() => this.submit()}>
                  <Button loading={this.state.submitting} type="primary">
                    Submit
                  </Button>
                </Popconfirm>
              ))}
          </div>
        </Card>
      </Fragment>
    )
  }
}

export default AddPayQuery
